import DocxEditorSyncFusion from './DocxEditorSyncFusion';

export default DocxEditorSyncFusion;